/* Caipi Redesign — Benefit strip pagination dots.
   Vanilla, dependency-free. Highlights the dot for the card nearest the
   scroller's left edge and lets dots scroll their card into view. Desktop
   (grid) hides the dots via CSS, so this is a no-op there. */
(function () {
  'use strict';

  function initTrack(track) {
    if (track.dataset.rdInit === '1') return;
    track.dataset.rdInit = '1';

    var root = track.closest('[data-section-id]');
    var dots = root ? root.querySelectorAll('[data-rd-benefits-dots] .rd-dot') : [];
    if (!dots.length) return;
    var cards = track.querySelectorAll('.rd-benefit');

    function update() {
      var trackLeft = track.getBoundingClientRect().left;
      var idx = 0, min = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - trackLeft);
        if (d < min) { min = d; idx = i; }
      });
      dots.forEach(function (dt, i) { dt.classList.toggle('rd-dot--active', i === idx); });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    dots.forEach(function (dt, i) {
      dt.addEventListener('click', function () {
        if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-rd-benefits]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
